module.exports = __webpack_public_path__ + "img/VancouverFlughafen.8f064485.svg";